/**
 * Created by yniran on 12/17/14.
 *
 *
 * this controller is in charge of retrieving data that is needed for starting the chat connection and for starting
 * a chat session (conversation).
 * Its in charge of retrieving SSO Key for the account to chat with, the visitor id
 *
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        CONST = require("const"),
        LEConfig = require("assets/config/le-env-conf"),
        SSOModel = require("connection-models/SSOModel"),
        ChatStartDataController = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger,
            CHAT_INFORMATION_STORAGE_KEY = "cp_chat_info_storage",
            CHAT_INFO_NO_VAL = -1;

        ChatStartDataController = Marionette.Controller.extend({

            initialize: function (options) {
                logger.debug("initialize : entered", "ChatStartDataController.initialize");

                this._chatChannel = options.chatChannel;

                this._bindEvents();

                this._chatInformation = null;
                this._visitorIdAttempt = 0;
                this._retrievingSSO = false;
                this._retrievingVisitorId = false;
                this._ssoAccountParam = this._getAccountParam();

                this._retrieveChatInfoFromStorage();
            },

            _bindEvents: function () {

                var cVent = this._chatChannel.vent;

                this.listenTo(LE.vent, "LPtag_mtaconfig:loaded", this._onMtagConfigReady);
                this.listenTo(cVent, "chatConnection:chat:ended", this._onChatEnded);
                this.listenTo(cVent, "chat::logout", this._onLogout);

                this._chatChannel.commands.setHandler("chatStartData:request:createChatInformation", this._getChatInformation, this);
            },

            _onChatEnded: function () {

                logger.debug("received chat ended notification, clearing chat information", "ChatStartDataController._onChatEnded");

                this._chatInformation = null;
            },

            _onMtagConfigReady: function () {
                this._retrieveTagVisitorId();
            },

            _getChatInformation: function (options) {

                if (options.contactModel && _.isObject(options.contactModel)) {
                    this._buildChatInfoFromContactDetails(options.contactModel);
                }

                this._retrieveSSO();  //need to fetch a new SSO key for every chat request
                this._publishInfoReady(); //if info is ready it will be send back to the caller immediately
            },

            _getBasicChatInformation: function () {

                var info = this._chatInformation;

                if (!info) { //create the chat information object for the first time
                    info = {
                        profileAvatarImg: window.leImageBaseUrl + "src/modules/connection/assets/img/chat-avatar-blue.png",  //the default icon for the user
                        defaultContactAvatarImg: window.leImageBaseUrl + "src/modules/connection/assets/img/chat-avatar-orange.png",
                        referrer: document.location.href,
                        ssoKey: null,    //retrieved from API
                        ssoServiceKey: LEConfig.ssoConfigurationKey,
                        ssoServiceExtraParams: this._ssoAccountParam,
                        visitorSessionId: null //retrieved from tag
                    };

                    this._chatInformation = info;
                }

                return info;
            },

            _buildChatInfoFromContactDetails: function (contactModel) {

                var info = this._getBasicChatInformation();

                info.contactAvatarImg = contactModel.get("img");

                delete info.agent;
                delete info.skill;

                var skill = contactModel.get("skillName");
                var backupSkill = contactModel.get("backupSkillName");
                info.contactDisplayName = contactModel.get("displayName").toLowerCase();

                if (skill) {
                    info.skill = skill;
                }
                if (backupSkill) {
                    info.backupSkill = backupSkill;
                }

                this._chatInformation = info;
            },

            _isChatInfoReady: function (info) {

                info = info || this._chatInformation;

                return (info && !this._retrievingSSO && !this._retrievingVisitorId);
            },

            _publishInfoReady: function () {

                if (this._isChatInfoReady()) {
                    this._chatChannel.vent.trigger("chatStartData:info:ready", _.clone(this._chatInformation));
                    this._persistChatInfoToStorage();
                }
            },

            _retrieveSSO: function () {
                //retriev sso but before retrieve JWT
                if (!LE.sessionManager || !LE.sessionManager.isAuthenticated()) { //dont retrieve sso if not logged in - need account id
                    this._onSuccessfulSSORetrieval(CHAT_INFO_NO_VAL);
                }
                else if (!this._retrievingSSO) {

                    logger.debug("about to retrieve SSO key from server", "ChatStartDataController._retrieveSSO");

                    this._retrievingSSO = true;

                    var model = new SSOModel();

                    model.save(null, {
                        success: _.bind(this._onSuccessfulSSORetrieval, this),
                        error: _.bind(this._onSSORetrievalError, this)
                    }).always(_.bind(function () {
                        this._retrievingSSO = false;
                        this._publishInfoReady();
                    }, this));
                }
            },

            _onSSORetrievalError: function (model, resp) {
                logger.error("failed to retrieve sso information", "ChatTabController._retrieveSSO", resp);
                logger.graph({name:"connection:ChatStartDataController:_onSSORetrievalError"});
                this._setSSOInformation(CHAT_INFO_NO_VAL);
            },

            _onSuccessfulSSORetrieval: function (model, resp) {
                logger.debug("retrieved sso information successfully!", "ChatTabController._retrieveSSO", resp);
                var key = (_.isNumber(model) ? model : model.get("ssoKey"));
                this._setSSOInformation(key);
            },

            _setSSOInformation: function (key) {

                var info = this._getBasicChatInformation();

                if (key !== CHAT_INFO_NO_VAL) {
                    info.ssoServiceKey = LEConfig.ssoConfigurationKey;  //make sure the full sso info is set
                    info.ssoServiceExtraParams = this._ssoAccountParam;  //make sure the full sso info is set
                }

                info.ssoKey = key;
            },

            _retrieveTagVisitorId: function () {

                var info = this._getBasicChatInformation();
                var maxAttempts = LEConfig.connectionPanelSettings.chat.visitorSessionMaxAttempts;
                var attemptInterval = LEConfig.connectionPanelSettings.chat.visitorSessionRetryInterval;

                var getIdFromTag = _.bind(function () {

                    if (this._visitorIdAttempt < maxAttempts) {
                        this._visitorIdAttempt += 1;

                        if (window.lpMTagConfig.LPSID_VAR) { //we have the visitor session id from mtag

                            info.visitorSessionId = window.lpMTagConfig.LPSID_VAR;
                            logger.debug("found visitor session id: " + info.visitorSessionId, "ChatStartDataController._retrieveTagVisitorId");

                            this._onVisitorIdRetrievalDone();
                        }
                        else {
                            logger.debug("no visitor session id yet. will try again attempt " + this._visitorIdAttempt + " out of " + maxAttempts, "ChatStartDataController._retrieveTagVisitorId");
                            setTimeout(getIdFromTag, attemptInterval); //try again soon
                        }
                    }
                    else { //no more attempts, cant get visitor id
                        logger.warn("reached max attempts to retrieve visitor session id, stopping now", "ChatStartDataController._retrieveTagVisitorId");
                        info.visitorSessionId = CHAT_INFO_NO_VAL;
                        this._onVisitorIdRetrievalDone();
                    }
                }, this);

                if (!this._retrievingVisitorId) {
                    if (window.lpMTagConfig) {
                        this._retrievingVisitorId = true;
                        getIdFromTag();
                    }
                }
            },

            _onVisitorIdRetrievalDone: function () {

                this._visitorIdAttempt = 0;
                this._retrievingVisitorId = false;

                this._publishInfoReady();
            },

            _persistChatInfoToStorage: function () {

                var persistInfo = _.extend({}, this._chatInformation, { //remove the sso info before persisting to storage
                    ssoKey: null,
                    ssoServiceKey: null,
                    ssoServiceExtraParams: null
                });

                logger.debug("persisting chat information to the storage", "ChatStartDataController._persistChatInfoToStorage", persistInfo);

                $.localStorage(CHAT_INFORMATION_STORAGE_KEY, JSON.stringify(persistInfo));
            },

            _retrieveChatInfoFromStorage: function () {

                var persisted = $.localStorage(CHAT_INFORMATION_STORAGE_KEY);
                var info;

                if (persisted) {
                    try {
                        info = JSON.parse(persisted);
                    }
                    catch (ex) {
                        logger.error("found chat info in storage but failed to de-serialize it", "ChatStartDataController._retrieveChatInfoFromStorage", ex);
                        logger.graph({name:"connection:ChatStartDataController:_retrieveChatInfoFromStorage:fail"});
                    }

                    if (info && this._isChatInfoReady(info)) {

                        logger.debug("found valid chat info in storage, will use it", "ChatStartDataController._retrieveChatInfoFromStorage", info);
                        this._chatInformation = info;
                    }
                }
            },

            _getAccountParam: function () {

                var param;

                if (LE.loginInfo.accountId !== "new" && LE.context.get("persona") !== CONST.PERSONA.GUEST) {
                    param = JSON.stringify({
                        "account": LE.loginInfo.accountId
                    });
                }

                return param;
            },

            _onLogout: function () {
                logger.debug("application log out is taking place, removing data from local storage", "ChatStartDataController._onLogout");
                $.localStorage(CHAT_INFORMATION_STORAGE_KEY, null); //null makes the localstorage plugin remove data for ths key
            }
        });
    });

    return ChatStartDataController;
});
